/**
 * Copyright (c) 2022 Strategio Digital s.r.o.
 * @author Jiří Zapletal (https://strategio.digital, jz@strategio.digital)
 */

const toFormattedPrice = (price: number, currency: string): string => {

    const formatter = new Intl.NumberFormat('cs', {
        style: 'currency',
        currency: currency
    })

    return formatter.format(price)
}

export const priceHelper = () => {
    return {
        toFormattedPrice
    }
}